import styled from "styled-components";
import { InfoWrapper } from "../SinfleNftInfo/SinfleNftInfo.styled";

export const TableWrapper = styled(InfoWrapper)`
  margin-top: 40px;
  & h5 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    padding: 10px 0;
  }
`;

export const TableRow = styled.div`
  display: flex;
  padding: 10px 0;
  @media (max-width: 768.98px) {
    padding: 5px 0;
  }
  & div:first-child {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 126.2%;
    color: #6b6b6b;
    width: 50%;
    @media (max-width: 768.98px) {
      font-size: 14px;
    }
  }

  & div:nth-child(2) {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 126.2%;
    width: 50%;
    display: flex;
    justify-content: flex-end;
    color: ${(props) => props.theme.textColor};
    @media (max-width: 768.98px) {
      font-size: 14px;
    }
    & button {
      border: none;
      background: transparent;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding-right: 0;
      & svg {
        & path {
          stroke: ${(props) => props.theme.textColor};
        }
      }
    }
  }
`;
